module.exports = __webpack_public_path__ + "static/img/1.b302aa8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/1.png
// module id = J4DA
// module chunks = 0